<div [formGroup]="scopeFg">
  <p class="filter-label"><strong>Ownership</strong></p>
  <clr-radio-container>
    <clr-radio-wrapper *ngFor="let scopeOp of scopeOptions | keyvalue">
      <input type="radio" clrRadio  formControlName="scope" [value]="scopeOp.value.key">
      <label>{{scopeOp.value.value}}</label>
    </clr-radio-wrapper>
  </clr-radio-container>
</div>
